/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
import { Button } from '../../../common/primitive';
import { close } from '../../asset/images';

const StyledSpan = styled.span`
  display: inline-block;
  height: 18px;
  width: 18px;

  > button {
    background: none;
    border: none;
    cursor: pointer;
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    line-height: 1;
    margin: 0;
    padding: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
`;

/**
 * 汎用 close button - survey widget 右上に表示する
 * @param {string} [color=red] red|green close `X` icon color
 * @param {*} props React.props - button へ付与します
 * - `onClick` - click 通知を行います
 * @return {*} React.node - close button を返します
 * @constructor
 */
const Close = ({ color = 'red', ...props }) => {
  return (
    <StyledSpan className={'Close'}>
      <Button {...props}>
        {/*
          src: close.green | close.red - red is default
        */}
        <img src={close[color] || close.red} alt="close" />
      </Button>
    </StyledSpan>
  );
};

Close.propTypes = {
  color: PropTypes.oneOf(['red', 'green', 'white']).isRequired,
};

export default Close;



// WEBPACK FOOTER //
// ./src/phase2/survey/component/button/Close.js